module.exports = __webpack_public_path__ + "components/home-header/static/header-7--small-7011351ddcc578de3075d3c2b13db413.jpg";